<template>
  <div class="charge">
    <div class="top">
      <Menu mode="horizontal" ref="slideMenu" :active-name="menu">
          <MenuItem :name="index+''" :to="p.url" v-for="(p,index) in navItems" :key="index">
            <Badge :count="p.count" type="error">
              <Icon :custom="p.icon" />
              {{p.menuName}}
            </Badge>
          </MenuItem>
      </Menu>
    </div>
    <div class="main">
      <router-view/>
    </div>
  </div>
</template>

<script>
import {noChargeCount} from '../../api/charge';
export default {
  name: 'Charge',
  data () {
    return {
      navItems:[],
      menu:'0'
    }
  },
  mounted(){
    this.$nextTick(()=>{
      // this.menu = this.$route.path.slice(1)
      this.$refs.slideMenu.updateOpened()
    
      this.$refs.slideMenu.updateActiveName();
    })
    this.getCount();
    this.getItem();
  },
  methods:{
    getCount(){
      noChargeCount({

      }).then(res => {
        console.log(res);
        this.navItems[0].count = res.count;
      });
    },
    getItem(){
      let data = [
         {icon:' iconfont icon-shoufei2',sn:'1',menuName:'待收费',url:'/waitcharge',count:0},
        {icon:' iconfont icon-shoufei3',sn:'2',menuName:'已收费',url:'/havecharge',count:0},
        {icon:' iconfont icon-tuifeijiaoyi',sn:'3',menuName:'已退费',url:'/haverefund',count:0},
      ];
      this.navItems = data;
      // this.$emit('showNavItems',this.navItems);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
.charge{
   overflow: scroll;
  height: 100%;
}
.top{
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/charge/Charge.vue